export const TC_ACCESS_TOKEN = 'tc_access_token';
export const TC_SESSION_KEY = 'tc_session_key';
export const JWT_CUSTOM_GROUPS = 'custom:groups';
export const SKIP_AUTHENTICATION = process.env.REACT_APP_SKIP_AUTH === 'true';
export const EARLIEST_ALLOWABLE_DATE = 'Nov 15, 2021';
export const LIVE_DATE = 'Nov 16, 2021';
export const LEGACY_PAGE_URL = 'http://www.tccustomerexpress.com/gasdaysummaryreport.html';
export const J_TO_TJ_CONVERSION_FACTOR1 = 1/1000000000000;
export const J_TO_MJ_CONVERSION_FACTOR1 = 1/1000000;
export const HOME_URL = "http://www.tccustomerexpress.com/ngtl.html";
export const EMAIL_VALIDATE = /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,})+$/;
export const PHONE_VALIDATE = /^([0-9]{1,2}?[-. ])?\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/;
export const NAME_VALIDATE = /^[A-Za-zÀ-ÖØ-öø-ÿ ]{2,30}$/;
